import { render, staticRenderFns } from "./pointData.vue?vue&type=template&id=329661f9&scoped=true&"
import script from "./pointData.vue?vue&type=script&lang=js&"
export * from "./pointData.vue?vue&type=script&lang=js&"
import style0 from "./pointData.vue?vue&type=style&index=0&id=329661f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329661f9",
  null
  
)

export default component.exports